import React from 'react';
import PrimaryHeading from '../../Utilities/PrimaryHeading';
import PrimaryContent from '../../Utilities/PrimaryContent';
import { Button } from '@mui/material';

const TokenExpired = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        height: 'calc(100vh - 64px)',
        textAlign: 'center',
      }}
    >
      <PrimaryHeading>Token Expired</PrimaryHeading>
      <PrimaryContent sx={{ mt: 1, mb: 2 }}>
        Your token has expired. Please go to the login screen to request a new password reset email.
      </PrimaryContent>
      <Button
        sx={{
          fontFamily: 'Lato, sans-serif',
          fontWeight: 700,
          fontSize: '14px',
          color: 'linear-gradient(270.29deg, #43B0D7 0.24%, #0D2663 99.75%)',
          textTransform: 'none',
          border: '1px solid linear-gradient(270.29deg, #43B0D7 0.24%, #0D2663 99.75%)',
          '&:hover': {
            backgroundColor: 'none',
          },
        }}
        variant="outlined"
        color="primary"
        href="/login"
      >
        Go to Login Screen
      </Button>
    </div>
  );
};

export default TokenExpired;
